<template>
    <el-dialog v-model="dialogShow" width="360px" title="请完善学生信息" center @close="closeEvent" :close-on-click-modal="false" :show-close="isPerson">
        <div class="login-container">
            <div class="login-title" v-if="!isPerson">您的账号尚未完善学生信息</div>
            <div class="login-form">
                <el-form ref="loginRef" :model="formData" :rules="formRules">
                    <el-row>
                        <el-col :span="24">
                            <el-form-item prop="studentName">
                                <el-input v-model="formData.studentName" placeholder="请输入学生姓名"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24">
                            <el-form-item prop="userAccount">
                                <el-input v-model="formData.userAccount" placeholder="请输入学生学籍号"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24">
                            <el-form-item prop="grade">
                                <el-select v-model="formData.grade" placeholder="请输入当前年级">
                                    <el-option v-for="item in gradeList" :key="item.dicItemCode" :label="item.dicItemName" :value="item.dicItemCode" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24">
                            <el-form-item prop="province">
                                <el-cascader style="width:100%" v-model="formData.province" :options="treeColumn" :props="treeProps" placeholder="请选择学校所在地区" />
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <div>
                <el-button style="width:100%" color="#ef8b25" class="footer-btn1" @click="bindStudent">确认绑定</el-button>
            </div>
        </div>
    </el-dialog>
</template>
<script lang="ts" setup>
import studentDialog from "./studentDialog.vue"
import { ref, reactive, onMounted, defineProps, defineEmits } from 'vue';
import { bindUserAccount, getArea, getUserInfo, getDict } from "@/api/common.js"
import { ElMessage, ElMessageBox } from 'element-plus'
import { useStore } from "vuex"
const store = useStore();
const userInfo = store.state.userInfo
const props = defineProps({
    popupShow: {
        type: Boolean,
        default: false
    },
    isPerson: {
        type: Boolean,
        default: false
    }
})
const dialogShow = ref(props.popupShow)
const loginRef = ref()
const formData = ref({
    studentName: '',
    userAccount: '',
    province: ''
})
const treeColumn = ref([])
const treeProps = {
    label: 'areaLabel',
    value: 'areaCode'
}
const gradeList = ref([])
const emitList = defineEmits(['close'])
const formRules = {
    province: [
        {
            message: '请选择学校所在地区',
            required: true
        }
    ]
}

function bindStudent() {
    loginRef.value.validate(valid => {
        if (valid) {
            console.log(formData.value)
            let params = {
                "areaCode": formData.value.province[2],
                "cityCode": formData.value.province[1],
                "provinceCode": formData.value.province[0],
                "studentName": formData.value.studentName || '',
                "userAccount": formData.value.userAccount || '',
                "grade": formData.value.grade || '',
            }
            bindUserAccount(params).then(res => {
                console.log(res)
                ElMessage.success('绑定成功')
                getUserInfo().then(res => {
                    store.dispatch('setLogin', res.data);
                    store.dispatch('setGradeTerm', res.data)
                    if (res.data.firstLogin) {
                        ElMessageBox.confirm(
                            '赠送21天会员，您已领取成功',
                            '提示',
                            {
                                confirmButtonText: '知道了',
                                cancelButtonText: '取消',
                                type: 'warning',
                                showClose: false,
                                showCancelButton: false
                            }
                        ).then(() => {
                            emitList('close')
                        })
                    } else {
                        emitList('close')
                    }
                })
            }).catch(err => {
                console.log(err)
            })
        }
    })
}

function getAreaList() {
    getArea().then(res => {
        treeColumn.value = res.data;
    })
}

function closeEvent() {
    emitList('close')
}

function getDictList() {
    getDict({
        dicCode: 'dd_grade'
    }).then(res => {
        gradeList.value = res.data || []
    })
}

onMounted(() => {
    getAreaList()
    getDictList()
    if (userInfo.userName) {
        formData.value.studentName = userInfo.userName
    }
    if (userInfo.userAccount) {
        formData.value.userAccount = userInfo.userAccount
    }
    if (userInfo.grade) {
        formData.value.grade = userInfo.grade
    }
    let arr = []
    arr.push(userInfo.provinceCode || '')
    arr.push(userInfo.cityCode || '')
    arr.push(userInfo.areaCode || '')
    formData.value.province = arr.every(item => {
        return item ? true : false
    }) ? arr : []
})

</script>
<style lang="scss" scoped>
@import "@/style/variable.scss";
.login-container {
    padding: 10px;
    .login-title {
        font-size: 20px;
        font-weight: bold;
        color: $base-text-color;
        margin-bottom: 10px;
    }
    .login-tabs {
        display: flex;
        font-weight: bold;
        color: $base-text-color;
        &>div {
            width: 100px;
            text-align: center;
            line-height: 24px;
        }
        .active {
            color: $base-color;
            border-bottom: 2px solid $base-color;
        }
    }
    .login-form {
        margin: 20px 0 0;
    }
}
</style>

